var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isKeyboardOpen)?_c('footer',[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("💻 with ❤️ & "),_c('a',{attrs:{"href":"//vuejs.org"}},[_vm._v("Vue.js")]),_vm._v(" in Barcelona")])
}]

export { render, staticRenderFns }